import React from "react";
import "./layout.scss";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen font-nunito">
      <Header />
      <div className="">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
